import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//import { User, Scale, Clipboard, Calendar, Receipt } from "lucide-react";
import { faUser, faScaleBalanced, faClipboard, faCalendar, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { formatCPF, formatDateDDMMYYYYHHMM } from "../utils/formats";
//import { cpf } from "../../../utils/formats";
//import formatDateSolicitation from "../../../utils/formatDateSolicitation";

const PatientCard = ({
  patient,
  onViewProcedures,
  onViewScheduledProcedures,
  onMakePayment,
  onViewBudget
}) => {
  return (
    <div className="patient-card">
      <div className="patient-avatar">
      <FontAwesomeIcon icon={faUser} size="xl" />
      </div>

      <div className="patient-info">
        <div className="patient-main-info align-items-center">
          <div className="patient-name-container">
            <h3 className="patient-name">{patient.name}</h3>
            <p className="patient-cpf">CPF: {formatCPF(patient.cpf)}</p>
            <p className="fw-semibold fs-6">
              <FontAwesomeIcon icon={faCalendar} className="text-muted" /> {formatDateDDMMYYYYHHMM(patient.patient.date_solicitation)}
            </p>
          </div>

          {/* <div 
          className="btn-whatsapp d-flex align-items-center justify-content-center rounded-circle text-white me-5"
          title="Contatar paciente por Whatsapp"
          onClick={() => {}}>
            <Phone size={24} style={{ alignSelf: 'center' }} />
          </div> */}

        </div>
        <div>

        </div>
      </div>
      <div
        className="patient-procedures"
        style={{ display: "flex", alignItems: "center" }}>
        <p>
          {(() => {
            // 1. Agendados: somente de procedures_by_date
            const agendadosCount = Object.entries(
              patient.procedures_by_date || {}
            ).reduce((acc, [, dateObj]) => {
              const allProcedures = Object.values(dateObj).flat();
              return acc + allProcedures.filter((p) => p.scheduled).length;
            }, 0);

            // 2. Não agendados: somente de procedures_by_date
            const naoAgendadosCount = Object.entries(
              patient.procedures_by_date || {}
            ).reduce((acc, [, dateObj]) => {
              const allProcedures = Object.values(dateObj).flat();
              return acc + allProcedures.filter((p) => !p.scheduled).length;
            }, 0);

            // 3. Pagos: somente de payment_status.paid
            const pagosCount = Array.isArray(patient.payment_status?.paid)
              ? patient.payment_status.paid.length
              : 0;

            return [agendadosCount, naoAgendadosCount, pagosCount].map(
              (count, index) => (
                <span
                  key={index}
                  style={{
                    marginRight: "0.5rem",
                    fontSize: "12px",
                    display: "flex",
                  }}>
                  {index === 0 ? (
                    <span
                      style={{
                        color: "green",
                        display: "flex",
                        fontWeight: "bold",
                        alignItems: "center",
                      }}>
                     <FontAwesomeIcon icon={faCalendar} style={{ marginRight: "0.5rem" }} />
                      Agendados: {count}
                    </span>
                  ) : index === 1 ? (
                    <span
                      style={{
                        color: "blue",
                        display: "flex",
                        fontWeight: "bold",
                        alignItems: "center",
                      }}>
                      <FontAwesomeIcon icon={faCalendar} style={{ marginRight: "0.5rem" }} />
                      Não agendados: {patient.procedures.length}
                    </span>
                  ) : (
                    <span
                      style={{
                        color: "orange",
                        display: "flex",
                        fontWeight: "bold",
                        alignItems: "center",
                      }}>
                      <FontAwesomeIcon icon={faReceipt} style={{ marginRight: "0.5rem" }} />
                      Pagos: {count}
                    </span>
                  )}
                </span>
              )
            );
          })()}
        </p>
      </div>

      <div className="patient-actions">
        <button
          className="budget-button"
          onClick={onViewBudget}
          aria-label="Montar orçamento"
          disabled={patient.pending.length === 0}>
          <FontAwesomeIcon icon={faScaleBalanced} />
          <span>Orçamento</span>
        </button>

        <button
          className="procedure-button"
          onClick={onViewProcedures}
          aria-label="Ver procedimentos disponíveis">
          <FontAwesomeIcon icon={faClipboard} />
          <span>Procedimentos</span>
        </button>

        <button
          className="scheduled-button"
          onClick={onViewScheduledProcedures}
          aria-label="Ver procedimentos agendados">
          <FontAwesomeIcon icon={faCalendar} />
          <span>Agendados</span>
        </button>

        <button
          className="payment-card-button"
          onClick={onMakePayment}
          aria-label="Realizar pagamento">
          <FontAwesomeIcon icon={faReceipt} />
          <span>Pagamento</span>
        </button>
      </div>
    </div>
  );
};

export default PatientCard;
